import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/redux_store'
import './Loader.scss'

const Loader: React.FC = () => {
  const isLoading = useSelector((state: RootState) => state.loader.isLoading)

  if (!isLoading) return null

  return (
    <div className="loader-overlay">
      <div className="loader-card">
        {/* Animated Ramen & FT SVG Loader */}
        <svg viewBox="0 0 200 200" className="loader-svg" xmlns="http://www.w3.org/2000/svg">
          <defs>
            {/* Gradient for F (top red, bottom orange) */}
            <linearGradient id="fGradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#ef4444" />
              <stop offset="50%" stopColor="#ef4444" />
              <stop offset="50%" stopColor="#f97316" />
              <stop offset="100%" stopColor="#f97316" />
            </linearGradient>

            {/* Gradient for T (top orange, bottom red - reverse order) */}
            <linearGradient id="tGradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#f97316" />
              <stop offset="50%" stopColor="#f97316" />
              <stop offset="50%" stopColor="#ef4444" />
              <stop offset="100%" stopColor="#ef4444" />
            </linearGradient>

            {/* Steam gradient */}
            <linearGradient id="steamGradient" x1="0%" y1="100%" x2="0%" y2="0%">
              <stop offset="0%" stopColor="#f97316" stopOpacity="0.8" />
              <stop offset="100%" stopColor="#f97316" stopOpacity="0" />
            </linearGradient>
          </defs>

          {/* Shadow */}
          <ellipse cx="100" cy="170" rx="45" ry="6" fill="rgba(0,0,0,0.15)" />

          {/* Seaweed (Nori) */}
          <rect x="120" y="85" width="28" height="28" rx="2" transform="rotate(15 134 99)" fill="#1c1917" stroke="#2e2a24" strokeWidth="1.5" />

          {/* Egg White */}
          <ellipse cx="115" cy="115" rx="14" ry="10" transform="rotate(-20 115 115)" fill="#ffffff" />
          {/* Egg Yolk */}
          <ellipse cx="112" cy="116" rx="8" ry="6" transform="rotate(-20 112 116)" fill="#fbbf24" />

          {/* Noodles */}
          <path d="M 68 115 Q 75 105 85 115 T 105 115 T 125 115" fill="none" stroke="#f59e0b" strokeWidth="4" strokeLinecap="round" />
          <path d="M 72 120 Q 82 110 92 120 T 112 120 T 132 120" fill="none" stroke="#fbbf24" strokeWidth="4.5" strokeLinecap="round" />
          
          {/* Bowl Outer Body */}
          <path d="M 60 110 C 60 155, 140 155, 140 110 Z" fill="#1e293b" />
          {/* Bowl Base Stand */}
          <path d="M 85 150 C 85 156, 115 156, 115 150 Z" fill="#0f172a" />

          {/* Rim Pattern */}
          <path d="M 58 110 H 142" stroke="#ef4444" strokeWidth="5" strokeLinecap="round" />
          {/* Rim details */}
          <path d="M 63 110 H 137" stroke="#0f172a" strokeWidth="3" strokeDasharray="4,6" strokeLinecap="butt" />

          {/* Steam Lines */}
          <g className="steam-container">
            <path d="M 75 95 Q 68 75 78 55 T 75 25" className="steam-line steam-1" />
            <path d="M 100 95 Q 93 70 103 45 T 100 15" className="steam-line steam-2" />
            <path d="M 125 95 Q 118 75 128 55 T 125 25" className="steam-line steam-3" />
          </g>

          {/* Sparkles/Indicators around FT */}
          <g className="sparkles">
            <line x1="68" y1="42" x2="74" y2="37" stroke="#f97316" strokeWidth="2" strokeLinecap="round" />
            <line x1="64" y1="53" x2="71" y2="53" stroke="#f97316" strokeWidth="2" strokeLinecap="round" />
            <line x1="132" y1="42" x2="126" y2="37" stroke="#f97316" strokeWidth="2" strokeLinecap="round" />
            <line x1="136" y1="53" x2="129" y2="53" stroke="#f97316" strokeWidth="2" strokeLinecap="round" />
          </g>

          {/* FT Text */}
          <g className="ft-text-group">
            {/* F (Proper): Split Color (Top Red, Bottom Orange) */}
            <text x="76" y="66" fontFamily="'Inter', -apple-system, sans-serif" fontWeight="900" fontSize="30" fill="url(#fGradient)" letterSpacing="2">F</text>
            {/* T (Proper, Straight): Split Color (Top Orange, Bottom Red) */}
            <text x="100" y="66" fontFamily="'Inter', -apple-system, sans-serif" fontWeight="900" fontSize="30" fill="url(#tGradient)" letterSpacing="2">T</text>
          </g>
        </svg>

        <p className="loader-brand">
          FoodTolls
        </p>
        <p className="loader-text">
          Loading...
        </p>
      </div>
    </div>
  )
}

export default Loader
